import { useEffect } from 'react';

export const useAutoRefresh = (
  onRefresh: () => Promise<void> | void,
  intervalMs: number
): void => {
  useEffect(() => {
    const runRefresh = () => {
      void onRefresh();
    };

    const intervalId = window.setInterval(runRefresh, intervalMs);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [intervalMs, onRefresh]);
};

export default useAutoRefresh;
